<template>
  <div class="stat-icons">
    <ArrowUpIcon
      class="stat__icon stat__icon--up"
      v-if="showUpIcon.value"
      v-tooltip="{
        content: `${showUpIcon.label}`,
        placement: 'top-center',
      }"
    />
    <MinusIcon
      class="stat__icon stat__icon--equals"
      v-if="showMinusIcon.value"
      v-tooltip="{
        content: `${showMinusIcon.label}`,
        placement: 'top-center',
      }"
    />
    <ArrowDownIcon
      class="stat__icon stat__icon--down"
      v-if="showDownIcon.value"
      v-tooltip="{
        content: `${showDownIcon.label}`,
        placement: 'top-center',
      }"
    />
  </div>
</template>

<script>
import { MinusIcon, ArrowDownIcon, ArrowUpIcon } from 'vue-feather-icons'

export default {
  name: 'StatIcon',
  components: {
    ArrowUpIcon,
    ArrowDownIcon,
    MinusIcon,
  },
  props: {
    stat: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showUpIcon() {
      const { lastMonth, currentMonth } = this.stat
      const value = currentMonth > lastMonth
      const label = !lastMonth
        ? `+${Math.ceil((100 - lastMonth) * currentMonth)}%`
        : `+${Math.ceil((100 / lastMonth) * currentMonth - 100)}%`
      return {
        value: value,
        label: `${label} from last month`,
      }
    },
    showMinusIcon() {
      const value = this.stat.currentMonth === this.stat.lastMonth
      const label = 'No changes'
      return {
        value: value,
        label: label,
      }
    },
    showDownIcon() {
      const { lastMonth, currentMonth } = this.stat
      const value = currentMonth < lastMonth
      const label = !currentMonth
        ? `-${Math.ceil((100 - currentMonth) * lastMonth)}%`
        : `-${Math.ceil((100 / currentMonth) * lastMonth)}%`
      return {
        value: value,
        label: `${label} from last month`,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.stat-icons {
  flex: 0 0 14px;
  margin-left: 15px;
  cursor: pointer;
}
.stat__icon {
  &--up {
    line,
    polyline {
      color: var(--positive-light);
    }
  }
  &--equals {
    line,
    polyline {
      color: var(--perfect-gray);
    }
  }
  &--down {
    line,
    polyline {
      color: var(--carnation);
    }
  }
}
</style>
